<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col">
       <h1>Home</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      home: (state) => state.home.home
    })
  },
  async created() {
    await this.loadHomeData();
  },
  methods: {
    ...mapActions('home', ['getHomeDataAction']),
    async loadHomeData() {
      await this.getHomeDataAction();
    }
  },
};
</script>
